import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import AIAssistant from "@/components/AIAssistant";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/pages/AuthCallback";

import Home from "@/pages/Home";
import Search from "@/pages/Search";
import CleanerProfile from "@/pages/CleanerProfile";
import Booking from "@/pages/Booking";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import PaymentResult from "@/pages/PaymentResult";
import CustomerDashboard from "@/pages/customer/CustomerDashboard";
import CleanerDashboard from "@/pages/cleaner/CleanerDashboard";
import CleanerOnboarding from "@/pages/cleaner/CleanerOnboarding";
import PayoutsReturn from "@/pages/cleaner/PayoutsReturn";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import Messages from "@/pages/Messages";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/search" element={<Search />} />
        <Route path="/cleaners/:id" element={<CleanerProfile />} />
        <Route path="/book/:cleanerId" element={<ProtectedRoute><Booking /></ProtectedRoute>} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/payment/success" element={<PaymentResult />} />
        <Route path="/payment/cancel" element={<PaymentResult />} />
        <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
        <Route path="/customer/*" element={<ProtectedRoute role="customer"><CustomerDashboard /></ProtectedRoute>} />
        <Route path="/host" element={<ProtectedRoute role="customer"><CustomerDashboard /></ProtectedRoute>} />
        <Route path="/cleaner/onboarding" element={<ProtectedRoute role="cleaner"><CleanerOnboarding /></ProtectedRoute>} />
        <Route path="/cleaner/payouts/return" element={<ProtectedRoute role="cleaner"><PayoutsReturn /></ProtectedRoute>} />
        <Route path="/cleaner/*" element={<ProtectedRoute role="cleaner"><CleanerDashboard /></ProtectedRoute>} />
        <Route path="/admin/*" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
      </Routes>
      <AIAssistant />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
